import { homeworkAddHomeworkData, homeworkDeleteHomework, homeworkEditHomework, homeworkGetHomeBaseData, homeworkGetHomeDirectoryData, homeworkQueryHomeworkApprove, homeworkUpdateHomeworkApprove } from '@/api/textbookResource';
import UploadFile from '@/components/FileUpload/index.vue';
export default {
  name: 'TextbookResource',
  components: {
    UploadFile
  },
  data() {
    return {
      searchForm: {
        searchText: '',
        typeCode: '',
        rangeTypeCode: '',
        gradeCode: '',
        courseCode: '',
        textbookName: '',
        directoryCode: ''
      },
      cascaderOptions: [{
        label: '类型',
        options: []
      }, {
        label: '学段',
        options: []
      }, {
        label: '年级',
        options: []
      }, {
        label: '学科',
        options: []
      }, {
        label: '教材',
        options: []
      }],
      cascaderSelect: [],
      unitData: [],
      formUnitData: [],
      defaultCheckedKeys: [],
      defaultExpandedKeys: [],
      listData: [],
      uploadFile: null,
      dialogVisible: false,
      isloading: false,
      dialogTitle: '新增文件',
      formData: {
        typeCode: '',
        rangeTypeCode: '',
        gradeCode: '',
        courseCode: '',
        textbookName: '',
        directoryCode: '',
        homeworkFile: '',
        homeworkFileName: '',
        homeworkFileList: [],
        answerFile: '',
        answerFileName: '',
        answerFileList: [],
        allCategory: [],
        homeworkName: ''
      },
      rules: {
        homeworkName: [{
          required: true,
          message: '请输入作业名称',
          trigger: 'blur'
        }],
        allCategory: [{
          required: true,
          message: '请选择所属分类',
          trigger: 'blur'
        }],
        directoryCode: [{
          required: true,
          message: '请选择所属目录',
          trigger: 'blur'
        }],
        homeworkFile: [{
          required: true,
          message: '请上传作业文件',
          trigger: 'blur'
        }],
        answerFile: [{
          required: true,
          message: '请上传答案文件',
          trigger: 'blur'
        }]
      },
      table: {
        list: [],
        tableHeader: [{
          label: "作业名称",
          name: "homeworkName",
          width: 135
        }, {
          label: "审批状态",
          name: "issuingUnit",
          width: 100
        }],
        listQuery: {
          pageNo: 1,
          pageSize: 10
        },
        operates: {
          show: false,
          width: "150px",
          list: [{
            svg: "edit",
            type: "text",
            filter: row => {
              // if (row.isCanEdit === "0") {
              //   return false;
              // } else {
              //   return true;
              // }
            },
            method: (index, row) => {
              console.log('edit', row, index);
              // if (row.isCanEdit === "0" && this.$route.meta.type !== 1) {
              //   this.$message.warning("不是本人不可编辑！");
              // } else {
              //   this.honorForm.id = row.id;
              //   this.honorForm.classCode = row.classCode;
              //   this.honorForm.explainMes = row.explainMes;
              //   this.honorForm.honorsName = row.honorsName;
              //   this.honorForm.issuingUnit = row.issuingUnit;
              //   this.honorForm.level = row.level;
              //   this.honorForm.obtainDate = row.obtainDate;
              //   this.honorForm.photoList = row.photoList;
              //   this.fileList = [];
              //   row.photoList.forEach(img => {
              //     this.fileList.push({
              //       name: "",
              //       url: Image_Path + img,
              //       raw: { fileUrl: img }
              //     });
              //   });
              //   this.isAdd = false;
              //   this.dialogVisible = true;
              // }
            }
          }, {
            svg: "del",
            type: "text",
            filter: row => {
              if (row.isCanEdit === "0") {
                return false;
              } else {
                return true;
              }
            },
            method: (index, row) => {
              // if (row.isCanEdit === "0") {
              //   this.$message.warning("不是本人不可删除！");
              // } else {
              //   this.$confirm("确定删除所选信息吗？", "删除", {
              //     confirmButtonText: "确定",
              //     cancelButtonText: "取消",
              //     type: "warning"
              //   }).then(() => {
              //     // this.delData(deleteClassHonors, row.id);
              //   });
              // }
              console.log('del', row, index);
            }
          }]
        },
        isMultiple: false,
        total: 0
      },
      formLoading: false
    };
  },
  mounted() {
    this.initData();
  },
  watch: {
    'formData.homeworkFileList': {
      handler(newVal, oldVal) {
        console.log('formData.homeworkFileList', newVal);
        if (newVal.length) {
          this.formData.homeworkFile = newVal[0].url;
          this.formData.homeworkFileName = newVal[0].name;
        } else {
          this.formData.homeworkFile = '';
          this.formData.homeworkFileName = '';
        }
      },
      deep: true
    },
    'formData.answerFileList': {
      handler(newVal, oldVal) {
        if (newVal.length) {
          this.formData.answerFile = newVal[0].url;
          this.formData.answerFileName = newVal[0].name;
        } else {
          this.formData.homeworkFile = '';
          this.formData.homeworkFileName = '';
        }
      },
      deep: true
    }
  },
  methods: {
    initData() {
      // 初始化选项
      homeworkGetHomeBaseData().then(res => {
        console.log('homeworkGetHomeBaseData', res);
        if (res.code === 'success') {
          this.cascaderOptions = this.recursive(res.data);
          // this.cascaderOptions = [
          //   { label: '类型', options: [] },
          //   { label: '学段', options: [] },
          //   { label: '年级', options: [] },
          //   { label: '学科', options: [] },
          //   { label: '教材', options: [] }
          // ];
          // this.cascaderOptions[0].options = this.recursive(res.data);
          // 默认选中值
          // this.cascaderSelect = this.cascaderOptions.map((item, index) => {
          //   switch (index) {
          //     case 0:
          //       this.searchForm.typeCode = item.options[0].value;
          //       break;
          //     case 1:
          //       this.searchForm.rangeTypeCode = item.options[0].value;
          //       break;
          //     case 2:
          //       this.searchForm.gradeCode = item.options[0].value;
          //       break;
          //     case 3:
          //       this.searchForm.courseCode = item.options[0].value;
          //       break;
          //     case 4:
          //       this.searchForm.textbookName = item.options[0].value;
          //       break;
          //   }
          //   return item.options[0];
          // });
        }
      }).catch(error => {
        console.error(error);
      });
      this.getList();
    },
    // 目录数据
    getDirectory() {
      homeworkGetHomeDirectoryData(this.searchForm).then(res => {
        if (res.code === 'success') {
          this.unitData = res.data.map(item => ({
            ...item,
            childDirectoryVoList: Array.isArray(item.childDirectoryVoList) && item.childDirectoryVoList.length ? item.childDirectoryVoList : null
          }));
          // this.defaultCheckedKeys = [this.unitData[0].directoryCode]
          // this.defaultExpandedKeys = [this.unitData[0].directoryCode]
          // this.searchForm.directoryCode = this.unitData[0].directoryCode;
          // this.listData = this.unitData[0].childDirectoryVoList
          // this.getList()
        }
      }).catch(error => {
        console.error(error);
      });
    },
    getFormUnitData(value, directoryCode) {
      console.log('getFormUnitData', value);
      const [typeCode, rangeTypeCode, gradeCode, courseCode, textbookName] = value;
      homeworkGetHomeDirectoryData({
        typeCode,
        rangeTypeCode,
        gradeCode,
        courseCode,
        textbookName
      }).then(res => {
        if (res.code === 'success') {
          this.formUnitData = res.data.map(item => ({
            ...item,
            childDirectoryVoList: Array.isArray(item.childDirectoryVoList) && item.childDirectoryVoList.length ? item.childDirectoryVoList : null
          }));
          this.formData.directoryCode = directoryCode || '';
        }
      }).catch(error => {
        console.error(error);
      });
    },
    // 列表数据
    getList() {
      homeworkQueryHomeworkApprove({
        ...this.searchForm,
        ...this.table.listQuery
      }).then(res => {
        console.log('homeworkGetHomeworkResource', res);
        if (res.code === 'success') {
          this.table.list = res.data.rows;
          this.table.total = res.data.total;
        }
      }).catch(error => {
        console.error(error);
      });
    },
    recursive(data) {
      return data.map(item => {
        const e = {};
        if ('rangetypeVoList' in item) {
          e['label'] = item.typeName;
          e['value'] = item.typeCode;
          e['options'] = Array.isArray(item['rangetypeVoList']) ? this.recursive(item['rangetypeVoList']) : null;
          // !this.cascaderOptions[1].options.length && (this.cascaderOptions[1].options = e.options);
        } else if ('gradeVoList' in item) {
          e['label'] = item.rangeTypeName;
          e['value'] = item.rangeTypeCode;
          e['options'] = Array.isArray(item['gradeVoList']) ? this.recursive(item['gradeVoList']) : null;
          // !this.cascaderOptions[2].options.length && (this.cascaderOptions[2].options = e.options);
        } else if ('courseList' in item) {
          e['label'] = item.gradeName;
          e['value'] = item.gradeCode;
          e['options'] = Array.isArray(item['courseList']) ? this.recursive(item['courseList']) : null;
          // !this.cascaderOptions[3].options.length && (this.cascaderOptions[3].options = e.options);
        } else if ('textbookVolist' in item) {
          e['label'] = item.courseName;
          e['value'] = item.courseCode;
          e['options'] = Array.isArray(item['textbookVolist']) ? this.recursive(item['textbookVolist']) : null;
          // !this.cascaderOptions[4].options.length && (this.cascaderOptions[4].options = e.options);
        } else {
          e['label'] = item.textbookName;
          e['value'] = item.textbookName;
          e['frontCover'] = item.imgUrl;
        }
        return e;
      });
    },
    recursiveData(data, startIndex) {
      if ('options' in data) {
        this.cascaderOptions[startIndex].options = data.options;
        this.cascaderSelect[startIndex] = data.options[0];
        this.recursiveData(data.options, startIndex + 1);
      }
    },
    handleSelectChange(v) {
      console.log('handleSelectChange', v);
      if (v && v.length > 0) {
        this.cascaderSelect.forEach((e, i) => {
          switch (i) {
            case 0:
              this.searchForm.typeCode = e;
              break;
            case 1:
              this.searchForm.rangeTypeCode = e;
              break;
            case 2:
              this.searchForm.gradeCode = e;
              break;
            case 3:
              this.searchForm.courseCode = e;
              break;
            case 4:
              this.searchForm.textbookName = e;
              break;
          }
        });
        this.searchForm.directoryCode = '';
        this.getDirectory();
      } else {
        this.searchForm.typeCode = '';
        this.searchForm.rangeTypeCode = '';
        this.searchForm.gradeCode = '';
        this.searchForm.courseCode = '';
        this.searchForm.textbookName = '';
        this.searchForm.directoryCode = '';
        this.unitData = [];
      }
      this.getList();
    },
    handleNodeClick() {
      this.getList();
    },
    changePage(index) {
      this.table.listQuery.pageNo = index;
      this.getList();
    },
    handleSearchChange() {
      this.table.listQuery.pageNo = 1;
      this.getList();
    },
    handleChange(val) {
      console.log('handleChange(val) {:', val);
    },
    handleFileChange(e) {
      this.uploadFile = e.target.files[0];
      this.uploadFileAction();
    },
    async uploadFileAction() {
      if (!this.uploadFile) {
        return this.$message.error('请选择文件');
      }
      const formData = new FormData();
      formData.append('file', this.uploadFile);
      try {
        // const res = await this.$http.post('/api/textbookResource/upload', formData)
        // if (res.code === 200) {
        //   this.$message.success('上传成功')
        // }
      } catch (error) {
        this.$message.error('上传失败');
      }
    },
    addFile() {
      console.log('addFile()');
      this.dialogTitle = '新增文件';
      this.dialogVisible = true;
      // this.formData.allCategory = this.cascaderSelect.map(item => item);
      // this.formData.directoryCode = this.searchForm.directoryCode;
    },
    editFile(row) {
      console.log('editFile(row)', row);
      this.dialogTitle = '编辑文件';
      const {
        id,
        homeworkName,
        typeCode,
        rangeTypeCode,
        gradeCode,
        courseCode,
        textbookName,
        directoryCode,
        homeworkFile,
        homeworkFileName,
        answerFile,
        answerFileName
      } = row;
      this.formData = {
        id,
        homeworkName,
        typeCode,
        rangeTypeCode,
        gradeCode,
        courseCode,
        textbookName,
        directoryCode,
        homeworkFile,
        homeworkFileName,
        answerFile,
        answerFileName
      };
      this.getFormUnitData([typeCode, rangeTypeCode, gradeCode, courseCode, textbookName], directoryCode);
      this.formData.allCategory = [typeCode, rangeTypeCode, gradeCode, courseCode, textbookName];
      this.formData.homeworkFileList = [{
        name: homeworkFileName,
        url: homeworkFile
      }];
      this.formData.answerFileList = [{
        name: answerFileName,
        url: answerFile
      }];
      // this.formData.directoryCode = this.searchForm.directoryCode;
      this.dialogVisible = true;
    },
    // 更新上传按钮状态
    upIsLoading(bool) {
      this.isloading = bool;
    },
    // 删除文件
    handleRemove(fileList, uploadRef) {
      let url = '';
      let urlName = '';
      fileList.forEach(item => {
        if (url) {
          url = url + ',' + item.raw.fileUrl;
          urlName = urlName + ',' + item.name;
        } else {
          url = item.raw.fileUrl;
          urlName = item.name;
        }
      });
      if (uploadRef === 'homeworkFile') {
        this.formData.homeworkFile = url;
        this.formData.homeworkFileName = urlName;
      } else if (uploadRef === 'answerFile') {
        this.formData.answerFile = url;
        this.formData.answerFileName = urlName;
      }
    },
    handlePreview(res, uploadRef) {
      const path = this.$refs[uploadRef].filePath;
      const name = this.$refs[uploadRef].fileNames;
      // await uploadFile(file.file).then(res => {
      if (res.code === 'success') {
        if (this.formData.files) {
          if (uploadRef === 'homeworkFile') {
            this.formData.homeworkFile = this.formData.homeworkFile + ',' + path;
            this.formData.homeworkFileName = this.formData.homeworkFileName + ',' + name;
          } else if (uploadRef === 'answerFile') {
            this.formData.answerFile = this.formData.answerFile + ',' + path;
            this.formData.answerFileName = this.formData.answerFileName + ',' + name;
          }
        } else {
          if (uploadRef === 'homeworkFile') {
            this.formData.homeworkFile = path;
            this.formData.homeworkFileName = name;
          } else if (uploadRef === 'answerFile') {
            this.formData.answerFile = path;
            this.formData.answerFileName = name;
          }
        }
      }
      // });
    },
    async submitForm(formRef) {
      await this.$refs[formRef].validate(async valid => {
        console.log('submitForm', valid, this.formData);
        const [typeCode, rangeTypeCode, gradeCode, courseCode, textbookName] = this.formData.allCategory;
        if (valid) {
          if (this.formData.id) {
            homeworkEditHomework({
              ...this.formData,
              typeCode,
              rangeTypeCode,
              gradeCode,
              courseCode,
              textbookName
            }).then(res => {
              if (res.code === 'success') {
                this.$message.success('编辑成功');
                this.getList();
                this.dialogVisible = false;
              } else {
                this.$message.error(res.msg || '编辑失败');
              }
            }).catch(err => {
              this.$message.error(err.msg || '编辑失败');
            });
            return;
          }
          homeworkAddHomeworkData({
            ...this.formData,
            typeCode,
            rangeTypeCode,
            gradeCode,
            courseCode,
            textbookName
          }).then(res => {
            if (res.code === 'success') {
              this.$message.success('新增成功');
              this.getList();
              this.formData.id = 'success';
              this.dialogVisible = false;
            } else {
              this.$message.error(res.msg || '新增失败');
            }
          }).catch(error => {
            console.error(error);
          });
        } else {
          this.$message.error('请填写完整信息');
        }
      });
    },
    resetForm() {
      if (this.formData.id) {
        this.formData = {
          typeCode: '',
          rangeTypeCode: '',
          gradeCode: '',
          courseCode: '',
          textbookName: '',
          directoryCode: '',
          fileName: '',
          homeworkFile: '',
          homeworkFileName: '',
          homeworkFileList: [],
          answerFile: '',
          answerFileName: '',
          answerFileList: [],
          allCategory: '',
          homeworkName: ''
        };
      }
    },
    handlePublish(row) {
      this.$confirm('确定' + (row.approveStatus === '0' ? '发布' : '取消发布') + '吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        homeworkUpdateHomeworkApprove({
          id: row.id,
          approveStatus: row.approveStatus === '0' ? '1' : '0'
        }).then(res => {
          console.log('homeworkApprove', res);
          if (res.code === 'success') {
            this.$message.success('操作成功');
            this.getList();
          } else {
            this.$message.error(res.msg || '操作失败');
          }
        });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消操作'
        });
      });
    },
    handleDelete(row) {
      this.$confirm('确定删除吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        homeworkDeleteHomework({
          id: row.id
        }).then(res => {
          console.log('homeworkApprove', res);
          if (res.code === 'success') {
            this.$message.success('操作成功');
            this.getList();
          } else {
            this.$message.error(res.msg || '操作失败');
          }
        });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消操作'
        });
      });
    },
    handleDownload(file, fileName) {
      const a = document.createElement("a");
      a.href = process.env.VUE_APP_BASE_API + '/storage' + file;
      a.download = fileName;
      a.click();
      a.remove();
    }
  }
};